import tags from "../../components/tags";
import { icons } from "../../components/html";
import { statusCodes } from "../../components/responses";

export default {
  "/labeling-standards": {
    get: {
      tags: [tags.sizeIdDatabase],
      summary: "Supported size labeling standards",
      description: `${icons.c}
      Return list of all size standards in SizeID.`,
      parameters: [{ $ref: "#/components/parameters/acceptsLanguages" }],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  id: {
                    type: "integer",
                    description: "unique identifier of size standard",
                    example: 2
                  },
                  name: {
                    type: "string",
                    description: "unique name of size standard",
                    example: "US"
                  }
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
